import { useCallback } from 'react';
import { useDeeplinkRedirectCallBack } from './useDeeplinkRedirect';
import { useFeature } from '@growthbook/growthbook-react';
import FEATURES from '../constants/featureToggling';

export const useTournamentLobbyDeeplinkValue = (): string => {
  const tournamentLobbyDeeplink = useFeature(
    FEATURES.TOURNAMENT_DEEPLINK
  ).value;

  return tournamentLobbyDeeplink;
};
export const useTournamentLobbyAvailable = (): boolean => {
  const tournamentLobbyDeeplink = useTournamentLobbyDeeplinkValue();

  return Boolean(tournamentLobbyDeeplink);
};

export const useTournamentLobbyRedirectCallback = () => {
  const tournamentLobbyDeeplink = useTournamentLobbyDeeplinkValue();
  const deeplinkRedirect = useDeeplinkRedirectCallBack();

  return useCallback(() => {
    deeplinkRedirect(tournamentLobbyDeeplink)();
  }, [deeplinkRedirect, tournamentLobbyDeeplink]);
};
